import { MutationTree } from 'vuex';
import { ErrorDetail } from '../../types';
import { ExecutionTimingListState } from './types';
import * as types from './mutation-types';

export const mutations: MutationTree<ExecutionTimingListState> = {
    // 実行タイミング一覧取得系
    [types.INDEX_START](state) {
        const indexState = state.index;
        state.list = undefined;
        indexState.error = false;
        indexState.errorTitle = undefined;
        indexState.errorDetails = undefined;
        indexState.isProcessing = true;
    },

    [types.INDEX_SUCCESS](state, resData: any) {
        const indexState = state.index;
        state.list = resData;
        indexState.isProcessing = false;
    },

    [types.INDEX_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const indexState = state.index;
        indexState.errorTitle = payload.errorTitle;
        indexState.errorDetails = payload.errorDetails;
        indexState.error = true;
        indexState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const indexState = state.index;
        indexState.isProcessing = false;
    },
};
